import { createSlice } from '@reduxjs/toolkit';
import { Contract } from 'modules/types/Contract';
import { fetchContractByNumber } from './thunks';

export interface ContractDetailsState {
  contract?: Contract;
  loading: boolean;
  error?: string;
}

const initialState: ContractDetailsState = {
  contract: undefined,
  loading: false,
  error: undefined,
};

export const contractDetailsSlice = createSlice({
  name: 'contractDetails',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch contract details
    builder.addCase(fetchContractByNumber.pending, (state) => {
      state.contract = undefined;
      state.loading = true;
      state.error = undefined;
    });
    builder.addCase(fetchContractByNumber.fulfilled, (state, action) => {
      state.contract = action.payload;
      state.loading = false;
      state.error = undefined;
    });
    builder.addCase(fetchContractByNumber.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload
        ? (action.payload as Error)?.message
        : action.error?.message;
    });
  },
});

export default contractDetailsSlice.reducer;
